import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 20,
        backgroundColor:'#f4f5f5',
        paddingLeft:15,
        paddingBottom:15
    },
    billTo: {
        marginTop: 20,
        paddingBottom: 3,
        fontFamily: 'Helvetica-Oblique'
    },
  });


  const BillTo = ({invoice}) => (
    <View style={styles.headerContainer}>
        <Text style={styles.billTo}>Adresse de facturation :</Text>
        <Text>{invoice.company.name}</Text>
        <Text>{invoice.billing_address.street} {invoice.billing_address.zip_code} {invoice.billing_address.city}</Text>
    </View>
  );
  
  export default BillTo